module.exports = __webpack_public_path__ + "static/media/image3.4b437d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image3.jpg
// module id = 37
// module chunks = 0